import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-cover-login',
  templateUrl: './auth-cover-login.component.html',
  styleUrls: ['./auth-cover-login.component.css']
})
export class AuthCoverLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
